import React, {createContext} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import en from "./strings/locale.en"
import zhCN from "./strings/locale.zhCN"
import zhTW from "./strings/locale.zhTW"
import {Download} from "./DownloadApp";

export interface AppCtxInfo {
    locale: string;
    message: any;
}

const getMessage = (language: string) => {
    let result = null;
    switch (language) {
        case "zh-CN":
            result = zhCN;
            break;
        case "zh-TW":
            result = zhTW;
            break;
        default:
            result = en;
            break;
    }
    return result;
}

const AppContext = createContext<AppCtxInfo>({
    locale: navigator.language,
    message: getMessage(navigator.language)
})

const handleMessage = (language: string) => {
    let result = null;
    switch (language) {
        case "zh-CN":
            result = zhCN;
            break;
        case "zh-TW":
            result = zhTW;
            break;
        default:
            result = en;
            break;
    }

    return result;
}

export function getString(key: string) {
    return currentResMap[key] || en[key] || key;
}

export function getLocal() {
    const match = window.location.search;
    return match ? match[1] : navigator.language;
}

function getCurrentLocal() {
    let locale;
    const search = window.location.search;
    if (search) {
        const start = search.indexOf("lang=");
        const end = search.indexOf("&");
        if (start > 0) {
            if (end < 0) {
                locale = search.slice(start + 5);
            } else {
                locale = search.slice(start + 5, end);
            }
        }
    }
    return locale || navigator.language;
}

export const currentLocale = getCurrentLocal();
let currentResMap = handleMessage(getCurrentLocal());


ReactDOM.render(
    <AppContext.Provider value={{
        locale: getLocal(),
        message: getMessage(getLocal())
    }}>
        <Download/>
    </AppContext.Provider>,
    document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
